export default __webpack_public_path__ + "static/media/search-black.a0317ccd.svg";